import { render, staticRenderFns } from "./Triangles.vue?vue&type=template&id=f98c06fe&scoped=true&"
import script from "./Triangles.vue?vue&type=script&lang=js&"
export * from "./Triangles.vue?vue&type=script&lang=js&"
import style0 from "./Triangles.vue?vue&type=style&index=0&id=f98c06fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98c06fe",
  null
  
)

export default component.exports